import { Link } from 'gatsby'
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
/* import Button from '../Button' */

interface MenuProps {
  show: boolean
  onClose: () => void
}

export default function Menu({ show, onClose }: MenuProps) {
  const [isMounted, setIsMounted] = useState(false)

  const items = [
    {
      title: 'Home',
      to: '/'
    },
    {
      title: 'Ubicación',
      to: '/ubicacion'
    },
    {
      title: 'Oficinas',
      to: '/oficinas'
    },
    {
      title: 'Amenidades',
      to: '/amenidades'
    }
  ]

  useEffect(() => {
    if (show) {
      const timeout = setTimeout(() => {
        setIsMounted(true)
      }, 0)
      return () => clearTimeout(timeout)
    }
  }, [show])

  useEffect(() => {
    if (!isMounted && show) {
      const timeout = setTimeout(() => {
        onClose()
      }, 300)
      return () => clearTimeout(timeout)
    }
  })

  if (!show) return null

  return ReactDOM.createPortal(
    <div
      className="fixed w-full h-screen top-0 left-0 z-50 cursor-pointer"
      onClick={() => setIsMounted(false)}
    >
      <div
        className={`menu h-full w-96 max-w-[calc(100vw-24px)] bg-black/60 overflow-auto no-scrollbar backdrop-blur-2xl transition-all duration-300 cursor-auto ${isMounted ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-full'} ${show ? 'show' : 'hide'}`}
      >
        <div
          className="w-full h-full flex flex-col"
          onClick={e => e.stopPropagation()}
        >
          <div className="flex items-end justify-between py-6 px-6">
            <span className="font-serif text-white text-lg">Menu</span>
            <button onClick={() => setIsMounted(false)}>
              <img src="/icons/close.svg" width={32} />
            </button>
          </div>
          <div className="px-6">
            {items.map((item, index) => (
              <div key={item.to} className="py-2 pl-2">
                <Link
                  key={item.title}
                  to={item.to}
                  className="font-serif text-3xl uppercase text-white hover:text-neutral-300 transition-colors duration-300 inline-flex gap-2"
                  onClick={() => setIsMounted(false)}
                >
                  <span className="text-base">0{index + 1}</span>
                  {item.title}
                </Link>
              </div>
            ))}
          </div>
          {/* <div className="px-10 py-6">
            <Link to="/files/Distrito-Alamos_Brochure-v2.pdf" target="_blank">
              <Button darkMode noUpperCase>
                Descarga Brochure
              </Button>
            </Link>
          </div> */}
          <div className="flex flex-col flex-1 px-8 pt-4 pb-12 justify-end text-white gap-4">
            <img src="/images/DA_icon.svg" width={120} className="py-4" />
            <p className="font-serif italic text-lg">Corregidora Norte #483</p>
            <p className="text-xs">
              <strong>© 2025 Distrito Alamos.</strong> La marca registrada
              Distrito Alamos y los logotipos relacionados están protegidos por
              derechos de autor. Las imágenes pueden ser ejemplos
              representativos de Distrito Alamos y no necesariamente representan
              el diseño exacto. Distrito Alamos se reserva el derecho de
              realizar cambios en cualquier producto. La referencia a nombres de
              terceros es solo para fines informativos y no necesariamente un
              respaldo o asociación de Distrito Alamos o viceversa.
            </p>
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}
